const FOOTER_DETAILS_MEDIA_QUERY = window.matchMedia('(max-width: 749px)');

function setFooterDetailsState() {
  document.querySelectorAll('.footer-block__details').forEach((details) => {
    if (FOOTER_DETAILS_MEDIA_QUERY.matches) {
      details.removeAttribute('open');
    } else {
      details.setAttribute('open', '');
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setFooterDetailsState);
} else {
  setFooterDetailsState();
}

FOOTER_DETAILS_MEDIA_QUERY.addEventListener('change', setFooterDetailsState);
